import { Card, DatePicker, Statistic, Space, Divider } from 'antd'
import React, { useEffect, useState } from 'react'
import service from '../../../@services'
import BasicForm from '../components/BasicForm'
import OrderTable from '../components/OrderTable'
import Selector from '../components/Selector'
import SelectStores from '../components/SelectStores'
import * as Utils from '../../../@utils'
const { RangePicker } = DatePicker

/**
 * @param {Object} values 需要格式化的对象
 * @param {String} formatStr 格式化样式 默认'YYYY-MM-DD HH:mm:ss'
 * @returns Object
 */
const format = (values, formatStr = 'YYYY-MM-DD HH:mm:ss') => {
  if (!values) return {}
  values.afterOrderTime = values.orderDateTime
    ? values.orderDateTime[0].format(formatStr)
    : null
  values.beforeOrderTime = values.orderDateTime
    ? values.orderDateTime[1].format(formatStr)
    : null
  values.deliveryStartTime=values.deliveryTime
  ? values.deliveryTime[0].format(formatStr)
  : null
  values.deliveryEndTime=values.deliveryTime
  ? values.deliveryTime[1].format(formatStr)
  : null
  return { ...values }
}

const OrderList = (props) => {
  const orderNo = props.location.query?.orderNo
  const [defaultValue, setDefaultValue] = useState({})
  const [init, setInit] = useState(false)
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    pageIndex: 1,
    pageSize: 20,
  })
  const [amount, setAmount] = useState(0)
  const [total, setTotal] = useState(0)
  const [num, setNum] = useState(0)
  const [list, setList] = useState([])
  /** 初始化渲染门店选择框 */
  const setDefault = (values) => {
    if (orderNo){
      setDefaultValue({ storeCode: [values], orderNo: orderNo })
    }else{
      setDefaultValue({ storeCode: [values] })
    }
    if (init) return
    setInit(true)
    if (orderNo){
      setFormData({ ...formData, storeCode: [values], orderNo: orderNo })
    }else{
      setFormData({ ...formData, storeCode: [values] })
    }
  }
  /** 表单筛选项字段及组件 */
  const fields = [
    {
      label: '所属门店',
      name: 'storeCode',
      select: 'stores',
      component: <SelectStores onOptionLoad={setDefault} />,
    },
    {
      label: '订单来源',
      name: 'chan',
      component: <Selector tag="orderChan" />,
    },
    {
      label: '订单类型',
      name: 'orderTypes',
      component: <Selector tag="orderType" style={{width: '220px'}}/>,
    },
    {
      label: '商品信息',
      name: 'productQueryKey',
      placeholder: '商品名称/条码/商品编码'
    },
    {
      label: '订单编号',
      name: 'orderNo',
    },
    {
      label: '订单状态',
      name: 'orderStatus',
      component: <Selector tag="orderStatus" />,
    },
    {
      label: '下单时间',
      name: 'orderDateTime',
      span: 12,
      component: (
        <RangePicker
          showTime
          allowClear
          placeholder={['请选择开始时间', '请选择结束时间']}
        />
      ),
    },
    {
      label: '发货时间',
      name: 'deliveryTime',
      span: 12,
      component: (
        <RangePicker
          showTime
          allowClear
          placeholder={['请选择开始时间', '请选择结束时间']}
        />
      ),
    },
    {
      label: '购买人姓名',
      name: 'buyerName',
    },
    {
      label: '购买人电话',
      name: 'buyerPhone',
    },
    {
      label: '收货人姓名',
      name: 'receiverName',
    },
    {
      label: '收货人电话',
      name: 'receiverPhone',
    },
    {
      label: '收货地址',
      name: 'receiverDetailAddr',
      placeholder: '请输入收货地址'
    },
    {
      label: '支付渠道',
      name: 'payWay',
      component: <Selector tag="payWay" keyValue="name" />,
    },
    {
      label: '配送方式',
      name: 'receiveWay',
      component: <Selector tag="receiveWay" keyValue="name" />,
    },
  ]
  /** 获取订单列表 */
  const getOrderList = () => {
    setLoading(true)
    let p1 = service.order.getOrderList({ ...formData })
    let p2 = service.order.queryOrderStatistics({ ...formData })
    return Promise.all([p1, p2])
      .then((res) => {
        setLoading(false)
        const { result, recordCount } = res[0] || {}
        const { amount, num } = res[1] || {}
        setList(result || [])
        setTotal(recordCount || 0)
        setAmount(amount || 0)
        setNum(num || 0)
      })
      .catch(() => {
        setLoading(false)
      })
  }
  /** 查询 */
  const submit = (values) => {
    let formatValues = format(values)
    setFormData({ ...formData, ...formatValues })
  }
  /** 导出 */
  const onExport = async (values) => {
    let formatValues = format(values)
    setFormData({ ...formData, ...formatValues })
    let file = await service.order.exportOrder({
      ...formData,
      ...formatValues,
    })
    const filename =
      '门店订单报表' + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
    Utils.download(file, filename)
  }
  /** 明细导出 */
  const onExportDetail = async (values) => {
    console.log(111111);
    let formatValues = format(values)
    setFormData({ ...formData, ...formatValues })
    let file = await service.order.orderProductExport({
      ...formData,
      ...formatValues,
    })
    const filename =
      '门店订单列表商品明细报表' + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
    Utils.download(file, filename)
  }
  useEffect(() => {
    init && getOrderList()
  }, [init, formData])
  return (
    <div className="order-page">
      <BasicForm
        name="order"
        fields={fields}
        onSearch={submit}
        onExport={onExport}
        onExportDetail={onExportDetail}
        defaultValue={defaultValue}
        authKey={{ search: '/order/list', export: '/order/export' }}
      />
      <Card>
        <Space
          className="total-box"
          size="large"
          split={<Divider type="vertical" />}
        >
          <Statistic title="总金额(元)" value={amount} />
          <Statistic title="交易笔数(笔)" value={num} />
        </Space>

        <OrderTable
          loading={loading}
          list={list}
          total={total}
          page={formData}
          rootProps={props}
          searchList={getOrderList}
          submit={(pages = {}) => setFormData({ ...formData, ...pages })}
        />
      </Card>
    </div>
  )
}
export default OrderList
